/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { getSelectedProductIdFromActionInput } from '@msdyn365-commerce-modules/retail-actions';
// import { IAny, ICreateActionContext, IGeneric } from '@msdyn365-commerce/core';
import { AttributeValue } from '@msdyn365-commerce/retail-proxy';
// import {getByIdAsync, searchByCriteriaAsync} from '@msdyn365-commerce/retail-proxy/dist/DataActions/ProductsDataActions.g';
import { getProductAdditionalDetailsAsync } from './getProductAdditionalDetails';

/**
 * GetCustomProductSpec Input Action
 */
export class GetCustomProductSpecficiationInput implements Msdyn365.IActionInput {
    // TODO: Construct the input needed to run the action
    public productId: number;

    public channelId: number;

    public config: any;

    constructor(productId: number, channelId: number, config: any) {
        this.channelId = channelId;
        this.productId = productId;
        this.config = config;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `GetCustomProductAdditionalDetails${this.productId}`;
    public getCacheObjectType = () => 'Spec';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

// TODO: Create a data model here or import one to capture the response of the action
// export interface IGetCustomProductSpecData {
//     text: string;
// }

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (inputData: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    const productId = getSelectedProductIdFromActionInput(inputData);
    if (productId) {
        return new GetCustomProductSpecficiationInput(+productId, +inputData.requestContext.apiSettings.channelId, inputData.config);

    }
    throw new Error('Unable to create SelectedVariantInput, no productId found on module config or query');
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function action(input: GetCustomProductSpecficiationInput, ctx: Msdyn365.IActionContext): Promise<AttributeValue[]> {
    const prodAttr: AttributeValue[] = new Array();
    const response = await getProductAdditionalDetailsAsync({ callerContext: ctx }, input.productId);
    if (response && response.length > 0) {
        // response = response.sort((x,y) => x.Interchange_Part_Number!.localeCompare(y.Interchange_Part_Number!));

        let attr: AttributeValue = {
            KeyName: 'Country Of Origin',
            Name: 'Country Of Origin',
            TextValue: response[0].CountryLongName === "" ? 'N/A' : response[0].CountryLongName
            , DataTypeValue: 5
        };
        prodAttr.push(attr);
        attr = {
            KeyName: 'Life Cycle Status',
            Name: 'Life Cycle Status',
            TextValue: response[0].ProductLifeCycleDescription === "" ? 'N/A' : response[0].ProductLifeCycleDescription
            , DataTypeValue: 5
        };
        prodAttr.push(attr);
    }
    else{
        let attr: AttributeValue = {
            KeyName: 'Country Of Origin',
            Name: 'Country Of Origin',
            TextValue: 'N/A'
            , DataTypeValue: 5
        };
        prodAttr.push(attr);
        attr = {
            KeyName: 'Life Cycle Status',
            Name: 'Life Cycle Status',
            TextValue: 'N/A'
            , DataTypeValue: 5
        };
        prodAttr.push(attr);
    }
    return prodAttr;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<AttributeValue[]>>action,
    id: 'GetCustomProductAdditionalDetails',
    input: createInput
});
